export default __webpack_public_path__ + "static/media/sports_token_black.f0ff35ea.png";